import React from 'react'
import PropTypes from 'prop-types'
import {UncontrolledTooltip} from 'reactstrap'

const CertificateRowCell = ({id, data, formatedData}) => {
  if (data) {
    const cellId = `CertificateCell_${id}`
    return (
      <div id={cellId}>
        {formatedData ? formatedData : data.map(o => o.name).join(', ')}
        <UncontrolledTooltip placement="right" target={cellId}>
          <ul className="list-unstyled">
            {data.map(o => <li key={`${id}_${o.id}`}>{o.name} - {o.description}</li>)}
          </ul>
        </UncontrolledTooltip>
      </div>
    )
  } else {
    return <div/>
  }
}

CertificateRowCell.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.array,
  formatedData: PropTypes.string,
}

export default CertificateRowCell



// WEBPACK FOOTER //
// ./src/components/Welders/helpers/CertificateRowCell.js